import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetDailyList } from '../../store/thunk/setGetDailyList';
import TemplatePage from '../../../components/templatePage';
import PaymentItem from '../../components/paymentItemWithdrawal';
import PaymentItemRelpenishment from '../../components/paymentItemReplenishment';
import { isArray } from 'lodash';
import { setLoadingAction } from '../../../components/templatePage/store/action';
import { setGetDailyListAction } from '../../store/action';
import moment from 'moment';

const handleLoadPagination = ({page, setPage, countPage}) => {
    if (page <= countPage) {
        setPage(page + 1);
    }
}

const handleLoading = (dispatch) => {
    dispatch(setLoadingAction(true))
}

const Finance = () => {
    const dispatch = useDispatch();
    const utc = moment.utc().valueOf();
    const [page, setPage] = React.useState(1);
    const [currentDate, setCurrentDate] = React.useState(utc)
    const [startDate, setStartDate] = React.useState(0);
    const [search, setSearch] = React.useState('');

    React.useEffect(() => {
        dispatch(setGetDailyList({
            search,
            page: 1,
            rowsPerPage: (page + 1) * 100,
            date_from: startDate,
            date_to: currentDate
        }));
    }, [search, page, startDate, currentDate, dispatch])

    const list = useSelector(state => state.cashiersMobile.dayli)

    return (
        <TemplatePage
            title="Финансовые операции"
            pagination={page < list.countPage && list.data.length}
            handleLoadPagination={() => handleLoadPagination({
                page,
                setPage,
                countPage: list.countPage
            })}
            handleLoading={() => handleLoading(dispatch)}
            datePicker
            changeDate={({date_from, date_to}) => {
                dispatch(setGetDailyListAction({
                    data: [],
                    countPage: 1
                })); 
                setCurrentDate(date_to);
                setStartDate(date_from);
                setPage(0);
            }}
            search={true}
            searchValue={search}
            onChangeSearch={(v) => {
                dispatch(setGetDailyListAction({
                    data: [],
                    countPage: 1
                })); 
                setSearch(v);
                setPage(0)
            }}
        >
            {
                list.data.map((item) => item.tag === 'replenishment' || (isArray(item) && item.length && item[0].tag === 'replenishment') ? <PaymentItemRelpenishment item={item}  array={isArray(item)}/> : <PaymentItem item={item}  array={isArray(item)}/>)
            }
            {
                !list.data.length && <span style={{width: '100%', color: '#fff', display: 'flex', justifyContent: 'center', padding: 20}}>Информация отсутствует</span>
            }
        </TemplatePage>
    )
}

export default Finance;